import React, { memo, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import { dispatch, useReframe } from 'nike-re-framejs';

import Accordion from '@/common/components/Accordion';
import TicketIcon from '@/icons/TicketIcon';
import ticketusClient from '@/_http/axiosTicketusClient';
import { normalizeSportEventId } from '../../domain/sportevent';
import { getPluralText } from '@i18n';
import useTicketDetail from '@/_hooks/useTicketDetail';
import imports from '@/routing/imports';
import { pickModule } from '@/common/lazy/Loadable';
import { loggedIn$ } from '@/account/subs';
import { activeMark, activeMatchTickets } from '@/mytickets/active/subs';
import { ticketusActiveMatchLoaded } from '@/mytickets/active/handlers';

const Ticket = React.lazy(() => imports.mytickets().then(pickModule('Ticket')));

function MatchTickets({ eventId }) {
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);
    const mark = subscribe(activeMark);
    const sportEventId = normalizeSportEventId(eventId);
    useEffect(() => {
        if (loggedIn) {
            ticketusClient
                .get('tickets/active-on-match', { params: { sportEventId } })
                .then(json => dispatch(ticketusActiveMatchLoaded(json)));
        }
    }, [loggedIn, mark, sportEventId]);

    const tickets = subscribe(activeMatchTickets);
    const ticketOnClick = useTicketDetail(tickets);

    if (!loggedIn) {
        return null;
    }

    return (
        <AnimateHeight height={tickets.length ? 'auto' : 0}>
            {tickets.length ? (
                <Accordion title={<TicketsTitle size={tickets.length} />} expanded={tickets.length === 1}>
                    <div className="tickets-overview-wrap detail-tickets">
                        <React.Suspense fallback={null}>
                            {tickets.map(ticket => (
                                <Ticket key={ticket.ticketId} ticket={ticket} onClick={ticketOnClick} />
                            ))}
                        </React.Suspense>
                    </div>
                </Accordion>
            ) : (
                <noscript />
            )}
        </AnimateHeight>
    );
}

function TicketsTitle({ size }) {
    const title = getPluralText('nikeone.onTickets.n', size, [1, 2]);
    return (
        <span className="detail-tickets-title">
            <TicketIcon width={20} height={20} fill={'#ff8000'} />
            {title}
        </span>
    );
}

export default memo(MatchTickets);
